import { useNode } from '@craftjs/core';
import { generateOnChange } from 'pages/PageEditor/settingsComponents/settingsHelpers';
import React, { useMemo } from 'react';
import { SwitchControl } from '../../settingsComponents';
import { EditorButtonBaseSettings } from './EditorButtonBaseSettings';

const EditorButtonSettings = () => {
	const {
		formNoValidate,
		actions: { setProp }
	} = useNode((node) => node.data.props);

	const [onFormNoValidateChange] = useMemo(
		() => ['formNoValidate'].map((attr) => generateOnChange(setProp, attr)),
		[setProp]
	);

	return (
		<div>
			<EditorButtonBaseSettings />
			<SwitchControl
				value={!formNoValidate}
				setValue={(v) => onFormNoValidateChange(!v)}
				label={intl.tr('screenEditor.settings.button.validate')}
				helpTooltip={intl.tr('screenEditor.settings.button.validate.tooltip')}
			/>
		</div>
	);
};

export { EditorButtonSettings };
